import React, { useCallback, useEffect, useState } from "react";
import ColorSelection from "../ColorSelection";
import PreviewBox from "../SectionBox/PreviewBox";
import SectionBoxWrapper from "../SectionBox/SectionBoxWrapper";
import PreviewCheckout from "./PreviewCheckout";
import PreviewBasket from "./PreviewCheckout";

export interface SectionBoxModeLoyaltyProps {
  themeConfig: any;
  onSubmit: any;
}

/* Update checkout information and users can view all checkout information using card. */
const SectionBoxModeLoyalty: React.FunctionComponent<
  SectionBoxModeLoyaltyProps
> = ({ themeConfig, onSubmit }) => {
  const [loyaltyBannerBackgroundColor, setLoyaltyBannerBackgroundColor] =
    useState("");
  const [modePopupBackgroundColor, setModePopupBackgroundColor] = useState("");
  const [modePopupButtonBackgroundColor, setModePopupButtonBackgroundColor] =
    useState("");
  const [modePopupTextColor, setModePopupTextColor] = useState("");
  const [modePopupButtonTextColor, setModePopupButtonTextColor] = useState("");
  const [loyaltyBannerTextColor, setLoyaltyBannerTextColor] = useState("");

  /* Update states initial load and after update checkout information. */
  const setInitialData = useCallback(() => {
    const {
      loyaltyBannerBackground,
      modePopupBackground,
      modePopupButtonBackground,
      modePopupText,
      modePopupButtonText,
      loyaltyBannerText,
    } = themeConfig;

    setLoyaltyBannerBackgroundColor(loyaltyBannerBackground);
    setModePopupBackgroundColor(modePopupBackground);
    setModePopupButtonBackgroundColor(modePopupButtonBackground);
    setModePopupTextColor(modePopupText);
    setModePopupButtonTextColor(modePopupButtonText);
    setLoyaltyBannerTextColor(loyaltyBannerText);
  }, [themeConfig]);

  useEffect(() => {
    setInitialData();
  }, [setInitialData]);

  /* Send an API call to update checkout information after click save button. */
  const handleSave = () => {
    onSubmit({
      loyaltyBannerBackground: loyaltyBannerBackgroundColor,
      modePopupBackground: modePopupBackgroundColor,
      modePopupButtonBackground: modePopupButtonBackgroundColor,
      modePopupText: modePopupTextColor,
      modePopupButtonText: modePopupButtonTextColor,
      loyaltyBannerText: loyaltyBannerTextColor,
    });
  };

  const {
    loyaltyBannerBackground,
    modePopupBackground,
    modePopupButtonBackground,
    modePopupText,
    modePopupButtonText,
    loyaltyBannerText,
  } = themeConfig;

  return (
    <>
      <SectionBoxWrapper
        sectionTitle={"Modes Selection & Loyalty"}
        onSubmit={handleSave}
        onCancel={setInitialData}
        colorChangeSection={
          <div  style={{marginBottom: "12px"}}>
             <ColorSelection
              title={"Loyalty Banner Background"}
              colorCode={loyaltyBannerBackgroundColor}
              setColor={(color: any) =>
                setLoyaltyBannerBackgroundColor(color.hex)
              }
              setInitialData={() =>
                setLoyaltyBannerBackgroundColor(loyaltyBannerBackground)
              }
            />

            <ColorSelection
              title={"Loyalty Banner Text"}
              colorCode={loyaltyBannerTextColor}
              setColor={(color: any) => setLoyaltyBannerTextColor(color.hex)}
              setInitialData={() =>
                setLoyaltyBannerTextColor(loyaltyBannerText)
              }
            />

            <ColorSelection
              title={"Mode popup background"}
              colorCode={modePopupBackgroundColor}
              setColor={(color: any) => setModePopupBackgroundColor(color.hex)}
              setInitialData={() =>
                setModePopupBackgroundColor(modePopupBackground)
              }
            />
              <ColorSelection
              title={"Mode popup text"}
              colorCode={modePopupTextColor}
              setColor={(color: any) => setModePopupTextColor(color.hex)}
              setInitialData={() => setModePopupTextColor(modePopupText)}
            />
            <ColorSelection
              title={"Mode popup button background"}
              colorCode={modePopupButtonBackgroundColor}
              setColor={(color: any) =>
                setModePopupButtonBackgroundColor(color.hex)
              }
              setInitialData={() =>
                setModePopupButtonBackgroundColor(modePopupButtonBackground)
              }
            />

          

            <ColorSelection
              title={"Mode popup button text"}
              colorCode={modePopupButtonTextColor}
              setColor={(color: any) => setModePopupButtonTextColor(color.hex)}
              setInitialData={() =>
                setModePopupButtonTextColor(modePopupButtonText)
              }
            />
           
          </div>
        }
        previewSection={
          <PreviewBox bgColor={modePopupBackgroundColor}>
            <PreviewBasket
              loyaltyBannerBackgroundColor={loyaltyBannerBackgroundColor}
              modePopupBackgroundColor={modePopupBackgroundColor}
              modePopupButtonBackgroundColor={modePopupButtonBackgroundColor}
              modePopupTextColor={modePopupTextColor}
              modePopupButtonTextColor={modePopupButtonTextColor}
              loyaltyBannerTextColor={loyaltyBannerTextColor}
            />
          </PreviewBox>
        }
      />
    </>
  );
};

export default SectionBoxModeLoyalty;
